import { render, staticRenderFns } from "./ProjectsView.vue?vue&type=template&id=7b890f8f&scoped=true"
import script from "./ProjectsView.vue?vue&type=script&lang=ts"
export * from "./ProjectsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b890f8f",
  null
  
)

export default component.exports